<template>
  <div>
    <highcharts :options="options"
                :updateArgs="updateArgs"
                :style="`height: ${height}px`"></highcharts>
  </div>

</template>

<script>
  // *****************************************************************************************************************
  //                                                  IMPORTS
  // *****************************************************************************************************************
  import {Chart} from 'highcharts-vue'
  import Highcharts from 'highcharts'
  import treemap from 'highcharts/modules/treemap'
  import heatmap from 'highcharts/modules/heatmap'
  import threed from 'highcharts/highcharts-3d'

  threed(Highcharts)
  treemap(Highcharts)
  heatmap(Highcharts)
  export default {
    name: '',
    // *****************************************************************************************************************
    //                                                 MIXINS
    // *****************************************************************************************************************
    mixins: [],
    // *****************************************************************************************************************
    //                                                  PROPS
    // *****************************************************************************************************************
    props: {
      series: {
        required: true,
        type: Array
      },
      categories: {
        required: false,
        type: Array,
        default: () => { return [] }
      },
      yAxis: {
        required: false,
        type: Array,
        default: () => { return [] }
      },
      plotOptions: {
        required: false,
        type: Object,
        default: () => { return {} }
      },
      height: {
        required: false,
        type: Number,
        default: 250
      },
      exporting: {
        enabled: false
      }
    },
    // *****************************************************************************************************************
    //                                                  COMPONENTS
    // *****************************************************************************************************************
    components: {
      highcharts: Chart
    },
    data () {
      return {
        updateArgs: [true, true, true],
        options: {
          title: {
            text: null
          },
          chart: {
            zoomType: 'xy',
            panning: true,
            panKey: 'shift'
          },
          xAxis: {
            categories: this.categories,
            crosshair: true
          },
          yAxis: this.yAxis,
          plotOptions: this.plotOptions,
          series: this.series,
          tooltip: {
            shared: true
          }
        }
      }
    },
    // *****************************************************************************************************************
    //                                                HOOKS
    // *****************************************************************************************************************
    created () {
    },
    watch: {
      series () {
        this.addSeries()
      },
      categories () {
        this.addCategories()
      }
    },
    computed: {},
    // *****************************************************************************************************************
    //                                                METHODS
    // *****************************************************************************************************************
    methods: {
      addSeries () {
        this.options.series = this.series
      },
      addCategories () {
        this.options.xAxis.categories = this.categories
      }
      // ********************************************** VUEX COMMITS ***************************************************
      // ********************************************** REQUESTS *******************************************************
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/expertoRetail/components/charts/Highcharts.vue